module.exports = __webpack_public_path__ + "img/cartel-gr-color.22309410.svg";